<template>
  <div v-loading.fullscreen.lock="loading">
    <div class="container-fluid sinup-container">
      <div class="row window-hight">
        <!-- IZQUIERDA: FORMULARIO -->
        <div class="col-12 col-md-6 left-bg">
          <div class="inner-left-wrap p-2 p-md-5">
            <a href="https://homeoftraining.com" class="navbar-brand mb-3 mb-md-5">
              <img src="/signup-img/hot-logo.webp" width="186" />
            </a>

            <div class="signin-header pt-3">
              <h3 class="mb-0">
                Shift4 HOT Onboarding
                <img src="/signup-img/fire.svg" alt="" />
              </h3>
              <span class="d-block mb-4">
                Complete the fields below to finish your setup.
              </span>
              <span class="d-block mb-4">
                Hello <strong> {{ form.employee_email }} </strong>! Please enter your information below to complete your setup.
              </span>
            </div>

            <validation-observer v-slot="{ handleSubmit }" ref="formValidator">
              <form role="form" @submit.prevent="handleSubmit(onSubmit)">

                <div class="row">
                  <div class="col-12 col-md-6">
                    <base-input
                      alternative
                      class="mb-3 login-input singup-input"
                      name="First Name"
                      :rules="{ required: true }"
                      placeholder="First Name"
                      v-model="form.employee_first_name"
                    >
                    </base-input>
                  </div>
                  <div class="col-12 col-md-6">
                    <base-input
                      alternative
                      class="mb-3 login-input singup-input"
                      name="Last Name"
                      :rules="{ required: true }"
                      placeholder="Last Name"
                      v-model="form.employee_last_name"
                    >
                    </base-input>
                  </div>
                </div>

<!--                <div class="row">-->
<!--                  <div class="col-12 col-md-6">-->
<!--                    <base-input-->
<!--                      alternative-->
<!--                      class="mb-3 login-input singup-input"-->
<!--                      name="Email"-->
<!--                      :rules="{ required: true, email: true }"-->
<!--                      placeholder="Email"-->
<!--                      v-model="form.email"-->
<!--                    >-->
<!--                    </base-input>-->
<!--                  </div>-->
<!--                  <div class="col-12 col-md-6">-->
<!--                    <div class="pass-wrap position-relative">-->
<!--                      <base-input-->
<!--                        alternative-->
<!--                        class="mb-3 login-input position-relative singup-input"-->
<!--                        name="Password"-->
<!--                        :rules="{ required: true }"-->
<!--                        :type="passwordFieldType"-->
<!--                        placeholder="Password"-->
<!--                        v-model="form.password"-->
<!--                      >-->
<!--                      </base-input>-->
<!--                      <span class="eye-icon-pass" @click="togglePasswordVisibility">-->
<!--                        <img-->
<!--                          v-if="passwordFieldType === 'password'"-->
<!--                          src="/img/svg-icons/eye-cut-icon.svg"-->
<!--                          alt="Hide Password"-->
<!--                        />-->
<!--                        <img-->
<!--                          v-else-->
<!--                          src="/img/svg-icons/eye-icon.svg"-->
<!--                          alt="Show Password"-->
<!--                        />-->
<!--                      </span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->

                <div class="d-flex justify-content-between align-items-center mb-3">
                  <small class="text-muted">
                    <span style="color:#FE672C">*</span> All fields are required.
                  </small>
                  <small v-if="form.linkToken" class="text-muted">
                    Link Token loaded
                  </small>
                </div>

                <div class="d-flex justify-content-center signinbtn mb-4">
                  <base-button
                    native-type="submit"
                    class="d-block w-100 mb-1 mb-md-0"
                  >
                    Complete Setup
                  </base-button>
                </div>

                <p class="error" v-if="errors.invalid">{{ errors.invalid }}</p>
              </form>
            </validation-observer>
          </div>
        </div>

        <!-- DERECHA: PANEL VISUAL (MISMO ESTILO QUE LOGIN) -->
        <div class="col-12 col-md-6 right-bg">
          <div class="inner-right-wrap d-flex flex-column h-100 pt-5 pl-2 pl-md-5">
            <h2 class="text-white mb-2 mb-md-0">Connect Your System!</h2>
            <p class="text-white mb-5">
              This page completes your HomeOfTraining setup after starting the
              installation from Shift4.
            </p>
            <div class="img-wrap d-flex justify-content-end mt-auto">
              <img class="img-fluid" src="signup-img/admin-img.webp" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2/dist/sweetalert2.js";
import "sweetalert2/src/sweetalert2.scss";

export default {
  name: "Shift4LinkInstall",

  data() {
    return {
      loading: false,
      passwordFieldType: "password",
      form: {
        employee_first_name: "",
        employee_last_name: "",
        user_name: "",
        employee_email: "",
        linkToken: "",
        user_type: "individual",
        company_id: "",
      },
      errors: {
        invalid: "",
      },
    };
  },

  created() {
    const tokenFromQuery =
      this.$route.query.linkToken ||
      this.$route.query.link_token ||
      this.$route.query.linktoken;

    if (!tokenFromQuery) {
      Swal.fire({
        icon: "warning",
        title: "Missing Link Token",
        text: "No link token was found in the URL. If you came from Shift4, please use the installation link provided there.",
      });
      this.$router.push("/login");
      return;
    }

    this.form.linkToken = tokenFromQuery;
    this.fetchLinkTokenInfo();
  },

  methods: {
    async fetchLinkTokenInfo() {
      try {
        this.loading = true;
        const resp = await this.$http.get("shift4/get-information-link-token", {
          params: { linkToken: this.form.linkToken },
        });

        if (resp && resp.data) {
          const data = resp.data;

          if (data.user.email) this.form.employee_email = data.user.email;
          if (data.user.email) this.form.user_name = data.user.email;
          if (data.location) this.form.company_id = data.location.merchantId;
          if (this.form.company_id.length > 2) {
            this.form.user_type = "admin";
          }
        }
      } catch (error) {
        console.error("Error fetching link token info:", error);
        Swal.fire({
          icon: "error",
          title: "Link Token Error",
          text:
            (error.response && error.response.data && error.response.data.message) ||
            "We could not load the information associated with this link token.",
        });
        this.$router.push("/login");
      } finally {
        this.loading = false;
      }
    },

    async onSubmit() {
      this.loading = true;
      this.errors.invalid = "";

      try {
        const payload = {
          employee_first_name: this.form.employee_first_name,
          employee_last_name: this.form.employee_last_name,
          user_name: this.form.user_name,
          employee_email: this.form.employee_email,
          link_token: this.form.linkToken,
          user_type: this.form.user_type,
          company_id: this.form.company_id,
        };

        const resp = await this.$http.post("shift4/create/user", payload);

        Swal.fire({
          icon: "success",
          title: "Account Created",
          text:
            (resp && resp.data && resp.data.message) ||
            "Your account has been created successfully.",
        });

        await this.$router.push("/login");
      } catch (error) {
        console.error("Error creating Shift4 user:", error);

        let errorText = "Something went wrong. Please try again.";
        if (error.response && error.response.data) {
          if (error.response.data.message) {
            errorText = error.response.data.message;
          }
        }

        this.errors.invalid = errorText;

        if (errorText.includes("The user name has already been taken")) {
          errorText = "The user have registered previously. Please proceed to login.";
        }

        Swal.fire({
          icon: "error",
          title: "Unable to complete setup",
          text: errorText,
        });
        await this.$router.push("/login");

      } finally {
        this.loading = false;
      }
    },

    togglePasswordVisibility() {
      this.passwordFieldType =
        this.passwordFieldType === "password" ? "text" : "password";
    },
  },
};
</script>

<style scoped>
/* Copio lo esencial del login para que se vea igual */

::v-deep select.form-control,
::v-deep select.form-control option {
  font-family: "Inter", serif;
}
body,
html {
  height: 100%;
}

.form-section {
  background-color: #e4e8e8;
}

.login-section {
  background-color: #ececf9;
  padding: 0px;
}

.course-section {
  background-color: #ffffff !important;
  padding: 40px;
}

.error {
  color: red;
  text-align: center;
}

.py-5 {
  padding-bottom: 0px !important;
}

.mt--10 {
  margin-top: -10rem !important;
}

.singup-option {
  font-size: 15px;
}

.singup-option a {
  color: #1e1e1e;
  font-weight: 500;
}

.left-bg {
  background: #f3f3f3 url("/signup-img/signup_bg1.svg") no-repeat right bottom;
}

.right-bg {
  background: url("/signup-img/signup_bg2.svg") no-repeat center center;
  background-size: cover;
}

.img-wrap {
  margin-right: -15px;
}

html,
body,
.window-hight {
  height: 100vh;
}

.sinup-container {
  font-family: "Inter", serif;
  color: #1e1e1e;
}

.signin-header h3 {
  font-size: 40px;
  font-weight: 500;
  color: #1e1e1e;
  line-height: 50px;
}

.signin-header h3 img {
  margin-top: -13px;
}

.signinbtn .btn {
  background: linear-gradient(to bottom, #e48e39 0%, #ea2628 100%);
  border: 0;
  height: clamp(40px, 6vw, 60px);
  font-size: clamp(20px, 2.5vw, 25px);
  font-weight: normal;
  transform: none;
}
.signinbtn .btn:hover {
  opacity: 0.8;
}

.signinbtn .btn svg {
  margin-top: -4px;
}

.inner-right-wrap h2 {
  font-size: 50px;
  font-weight: 500;
}

.inner-right-wrap p {
  font-size: 20px;
  max-width: 70%;
}

@media (max-width: 767px) {
  .singup-input .form-control {
    height: 50px !important;
  }

  .signinbtn .btn {
    height: 50px;
  }

  .inner-right-wrap h2 {
    font-size: 30px;
  }

  .inner-right-wrap p {
    font-size: 18px;
    max-width: 100%;
  }
}
</style>
